<template>
  <section class="primaryInfo">
    <a
      name="home"
      style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : '',
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
          <h1>ToTokGame Privacy Policy</h1>
          <h3>Last updated: April 17, 2020 </h3>

          <p>
            The ToTokGame Center is hosted by ToTok Technology Limited, and the games
             (the "<strong>Games</strong>") provided by Amusement Planet Pte Ltd, (together "<strong>ToTokGame</strong>",
              "<strong>we</strong>", "<strong>us</strong>" or "<strong>our</strong>"). We are committed to protecting and respecting your 
              privacy and personal data at all times. This privacy policy sets out the 
              basis on which any personal data we collect from you, or that you provide 
              to us, through the use of our gaming center ("<strong>ToTokGame Center Services</strong>") 
              as provided via the instant messaging application ToTok ("<strong>ToTok</strong>" or the "<strong>App</strong>"), 
              will be processed by us. Please read the following information carefully to fully 
              understand our views and practices regarding your personal data and how we will 
              treat it. For information regarding the general use of the ToTokGame Center Services, 
              please see our <a href="/totok-game-terms">Terms of Use</a>. For information regarding the use of the App or 
              the privacy practices of ToTok, please visit <a href="https://totok.ai/terms">https://totok.ai/terms</a> and <a href="https://totok.ai/privacy">https://totok.ai/privacy</a>.
          </p>
          <p>
            If you wish to contact us with any questions in relation to this
            policy or our privacy practices, you may contact us by emailing
            <a href="mailto:privacy@totok.ai">privacy@totok.ai</a> or by
            contacting us via the App.
          </p>
          <p>
            At all times, we keep our privacy practices and the terms of this
            policy under review to ensure your personal data is processed as
            securely as possible. This policy was last updated on the date given
            above. Any changes to this policy will be posted within the App and,
            if possible, emailed to you.
          </p>
          <h2>1.Information We May Collect From You</h2>
          <p>
            Personal data, or personal information, means any information about
            an individual from which that person can be identified. To provide
            you with the ToTokGame Center Services, we must collect, store,
            transfer, analyse and otherwise process certain of your personal
            data.
          </p>
          <p>The personal data we process includes:</p>
          <ul>
            <li>
              <strong
                >Account data for the ToTokGame Center Services that we receive
                from ToTok:</strong
              >
              as you have an account with ToTok and we require certain of the
              personal data used by ToTok to provide the ToTokGame Center
              Services, we automatically receive certain personal data from
              ToTok when you start to open a ToTokGame account. This personal
              data is limited to your name, mobile number and ToTok UID.
            </li>
            <li>
              <strong
                >Account data for ToTokGame Center Services which we will
                request your consent for:</strong
              >
              when preparing your account with ToTokGame, we will also ask if
              you would like your nickname, Avatar and other ToTok profile
              personal data from your ToTok account to be shared with your
              ToTokGame account. This is not required to register your ToTokGame
              account but will enhance your user experience whilst operating the
              ToTokGame Center Services.
            </li>
            <li>
              <strong>Game data:</strong>
              through your use of the Games, we will collect data about your
              game statistics, scores and preferences, including how often you
              play the Games, so we can track your progress within a Game for
              your gaming experience and so we can show you other Games we think
              you will enjoy. This means that when you return to a Game, you
              will be able to begin at the stage you were the previous time you
              played the Game. Further, within certain Games, you have the
              option of creating a Game character. If you choose to do so, this
              Game character will be made public to other Game users.
            </li>
            <li>
              <strong>In-Game purchases:</strong> within certain Games, you have
              the option of purchasing certain add-ons such as virtual "goods"
              or virtual "money" in accordance with the ToTokGame Terms of Use.
              When making an in-Game purchase using any available method, the
              only personal data we will collect is a record that you made an
              in-Game purchase and we will retain such records whilst your
              account is active. We will not collect any other personal data
              when you make an in-Game purchase, including the financial data
              you use to make the purchase.
            </li>
            <li>
              <strong>ToTok friends:</strong> we will request access to your
              ToTok friends list which, if granted, will allow us to access your
              friends. If we have access, we can tell you which of your friends
              is also using ToTokGame Center Services to make the experience
              more beneficial and enjoyable for you, for example if we have
              access to your friends list, it is simple for you to select a
              friend from your friends list to play a Game with or invite to
              play a Game.
            </li>
            <li>
              <strong>Data from other ToTokGame users:</strong> we will collect
              your personal data when other users of the ToTokGame Center
              Services interact with you, for example when they send you a
              request to play a Game with them. Further, such as when we access
              your ToTok friends list with your consent as noted above, if
              another user of the ToTokGame Center Services has your details in
              their ToTok friends list and provides us consent to access such
              list, we will have access to your personal data.
            </li>
            <li>
              <strong>Camera and microphone:</strong> depending on which Games
              you choose to access, there may be in-Game functions which would
              require access to your camera and/or microphone. Before we access
              the camera and/or microphone in your device, we will request your
              consent.
            </li>
            <li>
              <strong>Query or complaint data:</strong> should you wish to ask
              us a query or make a complaint about our ToTokGame Center
              Services, such personal data will also be automatically added to
              your account.
            </li>
            <li>
              <strong>Technical, usage and cookie data:</strong> we collect
              information about your use of the ToTokGame Center Services,
              including how you use our ToTokGame Center Services, how often you
              use our ToTokGame Center Services, and the types of interactions
              you have when you use our ToTokGame Center Services for. We do
              this to better understand how to provide the ToTokGame Center
              Services, what our users like about our ToTokGame Center Services
              and what our users don’t like about the ToTokGame Center Services.
              Such information may include, if applicable, your preferences,
              such as your language preference, internet protocol (IP) address,
              your account login data, browser type and version, browser plug-in
              types and versions.
            </li>
            <li>
              <strong>Device information:</strong> we collect information about
              the device you use to access the ToTokGame Center Services
              including the hardware model, the version of the App you are
              using, the mobile network, and the time zone setting.
            </li>
          </ul>
          <h2>2. How We Use Your Personal Data</h2>
          <p>We use your personal data for the following reasons:</p>
          <ul>
            <li>to create your ToTokGame account;</li>
            <li>
              to provide you with, and operate, the ToTokGame Center Services;
            </li>
            <li>to keep a record of the in-Game purchases you make;</li>
            <li>
              for anti-fraud and risk identification and management purposes. We
              use your personal data to comply with legal obligations relating
              to fraud and other financial crimes, and to ensure you, your
              personal data and your finances are protected;
            </li>
            <li>
              to verify activity, and to promote safety and security on and off
              our ToTokGame Center Services. Should we believe you have breached
              our Terms of Use for either the ToTokGame Center Services or for
              the use of ToTok, or are acting suspiciously, we may conduct an
              investigation to ensure you are not breaking the law or violating
              the Terms of Use;
            </li>

            <li>
              to communicate with you about your account, including with respect
              to any potential fraudulent activity or potential violation of the
              ToTokGame Terms of Use;
            </li>
            <li>
              to keep records of your progress within a Game, for example your
              score or the level you have you have reached;
            </li>
            <li>to suggest Games to you which we think you may enjoy;</li>
            <li>
              to send you marketing materials, including in relation to other
              products and services provided by our group companies;
            </li>
            <li>to respond to any of your queries; and</li>
            <li>to improve and customize our ToTokGame Center Services.</li>
          </ul>
          <p>
            We only process your personal data when it is lawful for us to do
            so. We rely on the following lawful grounds to process your personal
            data:
          </p>
          <ul>
            <li>
              if you provide your consent, for example with respect to receiving
              marketing communications, or allowing us to access your friends
              list;
            </li>
            <li>
              for the performance of the Terms of Use being the contract that
              you agree to enter into with us when using our ToTokGame Center
              Services, for example we process your personal data to provide you
              with the ToTokGame Center Services;
            </li>
            <li>
              compliance with a legal obligation to which we are subject, for
              example in relation to fraudulent activity;
            </li>
            <li>
              to protect your vital interests or those of another natural
              person, for example if we are investigating a report of harmful
              conduct submitted by you;
            </li>
            <li>
              performance of a task carried out in the public interest, for
              example to the extent this relates to the safety and security of
              our Service users and others; and/or
            </li>
            <li>
              the legitimate interests pursued by us or by a third party as
              listed below, subject at all times to us ensuring your rights and
              freedoms do not outweigh the pursued interests.
            </li>
          </ul>
          <p>The legitimate interests we pursue are:</p>
          <ul>
            <li>
              to constantly improve and customize our ToTokGame Center Services;
            </li>
            <li>
              to ensure the safety and security of our ToTokGame Center Service
              users and third parties, and to promote such safety and security;
              and
            </li>
            <li>
              to secure our ToTokGame Center Services from harmful acts such as
              cyber-security breaches.
            </li>
          </ul>
          <h2>3. Sharing Your Personal Data</h2>
          <p>
            We may share your personal data in the following scenarios only:
          </p>
          <ul>
            <li>we may share your personal data with your consent;</li>
            <li>
              we may share your personal data with other users who are using
              ToTokGame Center Services to ensure you both receive the full
              benefit of the ToTokGame Center Services offered. You also use our
              ToTokGame Center Services to share your own personal data with
              other users of the ToTokGame Center Services;
            </li>
            <li>
              by providing personal data to form part of your public profile
              either for use of all Games or for the specific in-Game characters
              you create, any such personal data displayed on your profile or as
              part of your in-Game character will be visible by other users of
              the ToTokGame Center Services;
            </li>
            <li>
              we may share your personal data with certain group companies to
              analyse our ToTokGame Center Services so we can improve and
              provide the best ToTokGame Center Services to you and others;
            </li>
            <li>
              we may share your personal data if we are required to respond to
              law enforcement, officials, regulatory agencies and other lawful
              requests or legal processes, or to comply with a legal obligation
              to which we are subject;
            </li>
            <li>
              we may share your personal data with if we undergo a merger,
              acquisition or other form or reorganization and pursuant to such,
              a third party will become the controller of your personal data;
              and/or
            </li>
            <li>
              we may share your personal data with group companies if you
              request a good or service provided by one of our group companies,
              or if one of our group companies provides us with services which
              relate to the provision of ToTokGame Center Services to you.
            </li>
          </ul>
          <p>
            In accordance with the laws of the UAE, we will store your
            transaction and other account data within the UAE. Notwithstanding
            this, if we are required and permitted by law to transfer any of
            your personal data to a country outside that in which we collected
            it pursuant to the above listed circumstances, we will do so in
            accordance with the applicable data privacy legislation. The lawful
            requirements will depend on the flow of personal data, meaning it
            will depend on whether the sharing of personal data is cross-border
            and which countries are involved. At all times, we will ensure a
            similar degree of protection is afforded to your personal data
            outside the country in which you are based.
          </p>
          <h2>4. Security Of Your Personal Data</h2>
          <p>
            We take your privacy very seriously and work hard to protect your
            data from being accidentally lost, used or accessed in an
            unauthorized way, altered or disclosed. We have put in place
            appropriate security measures to prevent this from happening, for
            example we use encryption tools to protect the content of your
            messages and calls. For additional information regarding the
            security of the App and the ToTokGame Center Services, please
            <a href="https://totok.ai/security">visit</a>.
          </p>
          <p>
            In addition, we limit access to your personal data to those
            employees, volunteers, agents, contractors and other third parties
            (as listed above) who have a need to know. They will only process
            your personal data on our instructions and they are subject to a
            duty of confidentiality.
          </p>
          <p>
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we will do our best to protect your
            personal data, we cannot guarantee the security of your data
            transmitted through our ToTokGame Center Services; any transmission
            is at your own risk. Once we have received your information, we will
            use strict procedures and security features to try to prevent your
            data from being accidentally lost, used or accessed in an
            unauthorized way, altered or disclosed.
          </p>
          <h2>5. How long we keep your personal data for</h2>
          <p>
            We will only retain your personal data for as long as reasonably
            necessary to fulfil the purposes we collected it for, including for
            the purposes of satisfying any legal, regulatory, tax, accounting or
            reporting requirements. To determine the appropriate retention
            period for personal data, we consider the amount, nature and
            sensitivity of the personal data, the potential risk of harm from
            unauthorized use or disclosure of your personal data, the purposes
            for which we process your personal data and whether we can achieve
            those purposes through other means, and the applicable legal,
            regulatory, tax, accounting or other requirements.
          </p>
          <p>
            With this in mind, we have determined that upon cancelling your
            account, we will store all data related to your account for up to
            one month from the date of cancellation before permanently deleting
            it.
          </p>
          <p>
            We may retain your personal data for a longer period in the event of
            a complaint or if we reasonably believe there is a prospect of
            litigation or other regulatory enforcement or action in respect to
            our relationship with you and/or your use of the ToTokGame Center
            Services.
          </p>
          <h2>6. Your rights</h2>
          <p>
            In certain circumstances and subject to certain jurisdictional
            restrictions, you may have the right to:
          </p>
          <ul>
            <li>
              <strong>Request access</strong> to your personal data (commonly
              known as a "data subject access request"). This enables you to
              receive a copy of the personal data we hold about you and to check
              that we are lawfully processing it.
            </li>
            <li>
              <strong>Request correction</strong> of the personal data that we
              hold about you. This enables you to have any incomplete or
              inaccurate data we hold about you corrected, though we may need to
              verify the accuracy of the new data you provide to us.
            </li>
            <li>
              <strong>Request erasure</strong> of your personal data. This
              enables you to ask us to delete or remove personal data where
              there is no good reason for us continuing to process it. You also
              have the right to ask us to delete or remove your personal data
              where you have successfully exercised your right to object to
              processing (see below), where we may have processed your
              information unlawfully or where we are required to erase your
              personal data to comply with local law.
            </li>
            <li>
              <strong>Object to processing</strong> of your personal data where
              we are relying on a legitimate interest (or those of a third
              party) and there is something about your particular situation
              which makes you want to object to processing on this ground as you
              feel it impacts on your fundamental rights and freedoms. You also
              have the right to object where we are processing your personal
              data for direct marketing purposes.
            </li>
            <li>
              <strong>Request restriction of processing</strong> of your
              personal data. This enables you to ask us to suspend the
              processing of your personal data in certain scenarios.
            </li>
            <li>
              <strong>Request the transfer</strong> of your personal data to you
              or to a third party. We will provide to you, or a third party you
              have chosen, your personal data in a structured, commonly used,
              machine-readable format.
            </li>
            <li>
              <strong>Withdraw consent</strong> at any time where we are relying
              on consent to process your personal data.
            </li>
            <li>
              <strong>Complain</strong> to the appropriate regulator for any
              data protection issues. We would, however appreciate the chance to
              deal with your concerns before you approach the regulator so
              please contact us in the first instance.
            </li>
          </ul>
          <p>
            To exercise one of the above rights, please contact us using the
            details provided above.
          </p>
          <p>
            We may need to request specific information from you to help us
            confirm your identity and ensure you are able to exercise the right
            you wish to exercise. This is a security measure to ensure that
            personal data is not disclosed to any person who has no right to
            receive it. We may also contact you to ask you for further
            information in relation to your request to speed up our response.
          </p>
          <p>
            We try to respond to all legitimate requests within one month.
            Occasionally it could take us longer than a month if your request is
            particularly complex or you have made a number of requests. In this
            case, we will notify you and keep you updated.
          </p>
          <h2>7. Third party links</h2>
          <p>
            Our ToTokGame Center Services may include links to third-party
            websites, plug-ins and applications. Clicking on those links or
            enabling those connections may allow third parties to collect or
            share data about you. We do not control these third-party websites,
            plug-ins and/or applications and are not responsible for their
            privacy statements. When you leave our App, we encourage you to read
            the privacy policy of every website or application you visit or use.
          </p>
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner></FootBanner>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  name: "PrivacyGame",
  metaInfo() {
    return {
      title: "Privacy Policy - ToTok Game",
      meta: [
        {
          Description:
            "To check how ToTok collect and process your data, please read our privacy policy carefully",
        },
        { property: "og:title", content: "Privacy Policy - ToTok Game" },
        { property: "og:url", content: "https://totok.ai/totok-game-privacy" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "Enjoy FREE, FAST and FUN calling with your family and friends.",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NavCrumbs,
    Footer,
    FootBanner,
  },
  data() {
    return {
      crumbProp: {
        label: "Privacy & Terms",
        type: "simple",
      },
      archivedVersionLabel: "(archived versions)",
      mainPannel: "",
      showinfo: false,
      isActive: "totok-game-privacy",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "totok-game-terms",
        },
        {
          title: "Privacy Policy",
          anchorId: "totok-game-privacy",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(item) {
      this.isActive = item;
      this.$router.push(item);
    },
  },
  mounted() {
    this.mainPannel = document.getElementById("mainbox");
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .innerBox {
        padding-bottom:60px;
    }
    .primaryInfo {
        padding: 0.8rem 0px;
        background: #fafafa;
        height: 82vh;

        div {
            margin-left 20px
            margin-right 20px
        }

        .leftMenu {
            display none
        }

        .info {

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fafafa;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: center;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 620px;
            margin: 20px 0;
            margin-bottom:60px;
            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
